import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";

const EditUserDialog = ({ open, onClose, onSave, user, onBecome, onEditQuestions, onEditReports }) => {
  const [editedData, setEditedData] = useState(user);

  useEffect(() => {
    // *Reset the edited data when the user prop changes
    setEditedData(user);
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleCheckboxChange = (e) => {
    const { name } = e.target;
    setEditedData((prevData) => ({ ...prevData, [name]: (!prevData[name]) }));
  };

  const handleSave = () => {
    onSave(editedData);
  };
  
  const handleBecome = () => {
    onBecome(editedData);
  };

  const handleEditQuestions = () => {
    onEditQuestions(editedData);
  };

  const handleEditReports = () => {
    onEditReports(editedData);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Edit User Details</DialogTitle>
      <DialogContent>
        <form>
          <TextField
            label="Full Name"
            name="username"
            value={editedData.username}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Email Address"
            name="email"
            value={editedData.email}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Contact Number"
            name="number"
            value={editedData.number}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="New password (Blank to leave unchanged)"
            name="newPassword"
            onChange={handleChange}
            value={editedData.newPassword}
            fullWidth
            margin="normal"
          />
          Administrator: <Checkbox
            label="Administrator"
            size="large"
            name="isAdmin"
            checked={editedData.isAdmin}
            onChange={handleCheckboxChange}
            margin="normal"
          /><br></br>
          Stripe test: <Checkbox
            label="Stripe test"
            size="large"
            name="istest"
            checked={editedData.istest}
            onChange={handleCheckboxChange}
            margin="normal"
          />
          <TextField
            label="Maximum number of guests"
            name="total_guests"
            value={editedData.total_guests}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleEditQuestions} color="primary">
          Edit questions
        </Button>
        <Button onClick={handleEditReports} color="primary">
          Edit Reports
        </Button>
        <Button onClick={handleBecome} color="primary">
          Become user
        </Button>
         <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSave} color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditUserDialog;
